import { Typography } from '@mui/material';
import { ScrWrapper } from 'components';
import { FC, ReactNode } from 'react';

type Props = {
  headline: string;
  intro: string;
  children: ReactNode;
};

const LinkCard: FC<Props> = ({ headline, intro, children }) => {
  return (
    <ScrWrapper
      id={headline}
      variant="secondary"
      sx={{
        p: 2,
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }} component="h2">
        {headline}
      </Typography>
      <Typography sx={{ fontSize: '12px' }}>{intro}</Typography>
      {children}
    </ScrWrapper>
  );
};
export default LinkCard;
